// Auto-generated file.
// Don't edit/delete it manually!

import type {ComponentProps, ComponentType} from 'react';
import React, {forwardRef} from 'react';

const POWER_POINT = forwardRef((props, ref) => {
    return (
        
<svg {...props} version="1.1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
<path fill="#ca4931" d="M11.331 10.038h-4.631v-0.967h3.611v-0.449h-3.611v-0.758h3.611v-0.45h-3.611v-1.245c0.293 0.342 0.725 0.558 1.207 0.558 0.876 0 1.586-0.71 1.586-1.586 0-0 0-0 0-0v0h-1.586v-1.587c-0.484 0-0.916 0.217-1.207 0.557v-1.765h4.632l-0.001 7.693zM11.331 1.96h-4.63v-1.21l-6.7 1.162v8.814l6.7 1.162v-1.466h4.632c0.212 0 0.385-0.173 0.385-0.385v-7.693c0 0 0 0 0 0 0-0.213-0.172-0.385-0.385-0.386h-0z"></path>
<path fill="#ca4931" d="M8.152 3.328v1.587h1.587c0-0.876-0.711-1.587-1.587-1.587v0z"></path>
<path fill="#fefefe" d="M2.835 6.251c0.267 0.020 0.529 0.070 0.69-0.206 0.123-0.209 0.112-0.591-0.030-0.752-0.184-0.208-0.421-0.178-0.66-0.14v1.099zM2.816 8.219h-0.671v-3.745c0.517 0 1.033-0.015 1.545 0.010 0.135 0.006 0.292 0.107 0.392 0.21 0.381 0.393 0.381 0.883 0.267 1.372-0.101 0.435-0.382 0.741-0.825 0.849-0.22 0.053-0.456 0.043-0.708 0.065v1.24z"></path>
</svg>

    );
}) as ComponentType<ComponentProps<'svg'>>;

export default POWER_POINT;
